import {getSetting} from '@woocommerce/settings';
import {registerPaymentMethod, registerExpressPaymentMethod} from '@wc-stripe/blocks-express-checkout';
import {ExpressCheckoutContent} from '../express-checkout';
import {PaymentMethod, PaymentMethodLabel} from '@wc-stripe/blocks-components';
import {isCartPage} from '@wc-stripe/blocks-utils';
import Preview from './preview';

const data = getSetting('stripe_link_checkout_data');
const activeMethod = {link: 'auto'};

registerPaymentMethod({
    name: data.gatewayId,
    label: <PaymentMethodLabel
        title={data.title}
        paymentMethod={data.gatewayId}
        icons={data.icons}/>,
    ariaLabel: 'Link',
    activeMethod,
    availabilityKey: 'link',
    context: 'checkout',
    sections: data.sections,
    content: (
        <PaymentMethod
            data={data}
            name={data.gatewayId}
            activeMethod={activeMethod}
            isExpress={false}
            content={ExpressCheckoutContent}
        />
    ),
    edit: <Preview/>,
    supports: {
        showSavedCards: data.showSavedCards,
        showSaveOption: false,
        features: data.features
    }
});

registerExpressPaymentMethod({
    name: 'stripe_link_checkout_express',
    gatewayId: data.gatewayId,
    paymentMethodId: data.gatewayId,
    activeMethod,
    availabilityKey: 'link',
    context: () => isCartPage() ? 'cart' : 'express_checkout',
    sections: data.sections,
    content: (
        <ExpressCheckoutContent
            data={data}
            name='stripe_link_checkout_express'
            activeMethod={activeMethod}
        />
    ),
    edit: <Preview/>,
    supports: {
        showSavedCards: data.showSavedCards,
        showSaveOption: data.showSaveOption,
        features: data.features
    }
});